import * as bootstrap from 'bootstrap';

jQuery(document).ready(function($) {

    $('#wortfilter select').on('change', function(e) {
        $(this).parents('form').submit();
    });

    $('#wortfilter input[type="search"]').on('input', function(e) {
        if (!e.currentTarget.value && !e.inputType) {
            $(this).parents('form').submit();
        }
    });

    const editor = $('#words-editor');
    if (editor.length) {
        let multiEdit = $('#multiedit');

        editor.editableTableWidget();

        multiEdit.on('change', '#move_words', function(){
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Wörter verschoben werden?")) {
                    let selected = editor.find('input.word-check:checked');
                    let selectedRows = selected.map(function(){ return $(this).parents('tr'); }).get();
                    let selectedWords = selected.map(function(){ return this.value; }).get();

                    if (selectedWords.length > 0) {
                        $.get('/admin/words/move?id=' + selectedWords.join(',') + '&wg=' + groupId);

                        $.each(selectedRows, function (i, row) {
                            row.find('button[data-action="move"]').toggleClass('active');
                            row.find('.move-select').toggleClass('d-none');
                            row.find('td').addClass('bg-warning');
                            window.setTimeout(function () {
                                row.remove();
                            }, 280)
                        });
                        toast('Es wurden ' + selectedWords.length + ' Wörter nach "'+ targetName + '" verschoben', 'Wörter verschieben');
                    }
                }
            }
        });
        multiEdit.on('change', '#copy_words', function(){
            let groupId = $(this).val();
            if (groupId) {
                let targetName = $(this).find('option').get(this.selectedIndex).innerHTML;
                if (confirm("Sollen alle ausgewählten Wörter kopiert werden?")) {
                    let selected = editor.find('input.word-check:checked');
                    let selectedWords = selected.map(function(){ return this.value; }).get();
                    if (selectedWords.length > 0) {
                        $.get('/admin/words/copy?id=' + selectedWords.join(',') + '&wg=' + groupId);
                        toast('Es wurden ' + selectedWords.length + ' Wörter nach "'+ targetName + '" kopiert', 'Wörter kopieren');
                    }

                    this.selectedIndex = 0;
                }
            }
        });

        editor.on('click', 'input.word-check', function(){
            let selected = editor.find('input.word-check:checked');
            let selectedWords = selected.map(function(){ return this.value; }).get();
            if (selectedWords.length > 0) {
                multiEdit.show();
            } else {
                multiEdit.hide();
            }
        });

        editor.on('change', '.move-select select', function(e) {
            let select = $(this);
            let row = select.parents('tr');
            let wordId = row.data('row');
            let groupId = select.val();
            let groupName = $(select.find('option').get(this.selectedIndex)).text();
            let wordName = row.find('[data-field="wort"]').text();

            if (groupId && groupId.length) {
                if (confirm("Soll '" + wordName + "' nach '" + groupName.substring(2) + "' verschoben werden?")) {
                    row.find('button[data-action="move"]').toggleClass('active');
                    row.find('.move-select').toggleClass('d-none');

                    $.get('/words/move?id=' + wordId + '&wg=' + groupId);

                    row.find('td').addClass('bg-warning');
                    window.setTimeout(function(){
                        row.remove();
                    }, 180)
                }
            }
            this.selectedIndex = 0;
        });

        editor.on('change', 'td', function(evt, newValue) {
            let tr = $(this).parent();
            let field = $(this).data('field');
            let id = tr.data('row');
            let url = $('#words-editor').data('url');

            if (field === 'silben') {
                newValue = parseInt(newValue, 10);
                if (isNaN(newValue)) {
                    return false;
                }
            }

            if (field === 'fugen') {
                if (newValue === 'x' || newValue.length === 0) {
                    // okay
                } else {
                    return false;
                }
            }

            let data = {};
            data['id'] = id;
            data['field'] = field;
            data['value'] = newValue;

            // auf dem server speichern
            $.post(url, data);
        });

        editor.on('click', 'button', function(e) {
            let button = $(this);
            let url = $('#words-editor').data('del');
            let wort = $(this).data('wort');
            e.preventDefault();

            // löschen
            if ($(this).data('action') === 'delete') {
                if (confirm('Das Wort "'+wort+'" wirklich löschen?')) {
                    let tr = $(this).parents('tr');
                    let id = tr.data('row');

                    let data = {};
                    data['id'] = id;

                    $.post(url, data, function(r){
                        console.log(r);
                        tr.remove();
                    });
                }
            }

            // verschieben
            if ($(this).data('action') === 'move') {
                button.toggleClass('active');
                button.parents('tr').find('.move-select').toggleClass('d-none');
            }
        });
    }
});





